import React from "react";
import styles from "./styles.css";
function Anchor({ id, label }) {
    return (React.createElement("h2", { className: styles.container },
        React.createElement("a", { href: `#${id}` }, label)));
}
;
export default Anchor;
